import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { RouterModule, Routes } from '@angular/router';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { TabMenuModule } from 'primeng/tabmenu';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { LightboxModule as LightboxModules, LIGHTBOX_CONFIG, } from "@ngx-gallery/lightbox";
import { DialogModule } from 'primeng/dialog';


const routes: Routes = [
  { path: '', component: HomeComponent },
];

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    TabMenuModule,
    SlickCarouselModule,
    InfiniteScrollModule,
    LightboxModules,
    RouterModule.forChild(routes),
    DialogModule
  ]
})
export class HomeModule { }
